export const timeOfTheDay = {
  "Morning": false,
  "Afternoon": false,
  "Evening": false
}